import { supabase } from '@/services/supabase';
import type { UserRole } from './types';

export async function getUserRoles(userId: string): Promise<UserRole[]> {
  const { data, error } = await supabase.rpc('get_user_roles', {
    p_user_id: userId,
  });

  if (error) {
    throw new Error(`Failed to fetch user roles: ${error.message}`);
  }

  return (data ?? []).map((row: Record<string, unknown>) => ({
    id: row.id as string,
    user_id: row.user_id as string,
    role_id: row.role_id as string,
    organization_id: row.organization_id as string | null,
    granted_at: row.granted_at as string,
    role: {
      id: row.role_id as string,
      name: row.role_name as string,
      slug: row.role_slug as string,
      description: row.role_description as string | null,
      is_system: row.role_is_system as boolean,
      hierarchy_level: row.role_hierarchy_level as number,
    },
  }));
}

export async function getUserPermissions(userId: string): Promise<string[]> {
  const { data, error } = await supabase.rpc('get_user_permissions', {
    p_user_id: userId,
  });

  if (error) {
    throw new Error(`Failed to fetch user permissions: ${error.message}`);
  }

  return (data ?? []).map((row: { code: string }) => row.code);
}
